import { Injectable, signal } from '@angular/core';
import { ExternalApp } from '@core/models/external-app.model';

@Injectable({
  providedIn: 'root',
})
export class ExternalAppsService {
  private readonly STORAGE_KEY = 'external_apps';

  private appsSignal = signal<ExternalApp[]>(this.getApps());

  public externalApps = this.appsSignal.asReadonly();

  getApps(): ExternalApp[] {
    const data = localStorage.getItem(this.STORAGE_KEY);
    return data ? (JSON.parse(data) as ExternalApp[]) : [];
  }

  setApps(apps: ExternalApp[]) {
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(apps));
    this.appsSignal.update(() => apps);
  }

  updateApps(apps: ExternalApp[]) {
    this.appsSignal.update(() => apps);
  }
}
